export const FEATURE_SECTIONS = {
    HOME: 'section.home',
    STUDENTS: 'section.students',
    CALENDAR: 'section.calendar',
    FINANCE: 'section.finance',
    PROFILE: 'section.profile',
    WORK_TGS: 'section.work_tgs',
    TEAMS: 'section.teams',
    STUDENT_TAGS: 'section.student_tags',
    STAFF: 'section.staff',
    TUTORS: 'section.tutors',
    TRIAL_LESSONS: 'section.trial_lessons',
    SHIFTS: 'section.shifts',
    EVENTS: 'section.events',
    STATISTICS: 'section.statistics',
} as const

export const FEATURES = {
    FRONT: {
        ASSISTANT: 'section.staff',
        FINANCE_BY_TGS: 'finance.list',
        STUDENT_ARCHIVE: 'student_archive',
        PAYMENT_LANDING: 'home.payment_landing.search',
        SALARY: 'salary',
        CHANGE_ALL_STUDENTS_PAYMENT: 'change_all_students_payment',
        TUTOR_ARCHIVE: 'tutor_archive',
        TUTOR_FILTER_BY_TG: 'tutors.list',
        TUTOR_UPDATE: 'tutor_update',
        STUDENT_COMMENTS: 'student.card.comments.read',
        MANUAL_TRANSACTION: 'transactions.manual.create',
        GPH: 'idm.contracts.download_all',
        CAN_PENALIZE_ASSISTANTS: 'staff.penalties_bonuses.create',
        TUTOR_ACCRUAL: 'tutors.payouts.read',
        TUTOR_PENALTY_BONUS: 'tutors.penalties_bonuses.read',
    },
    TUTORS: {
        LIST: 'tutors.list',
        READ: 'tutors.read',
        UPDATE: 'tutor_update',
        DELETE: 'tutors.delete',
        ARCHIVE: 'tutors.archive',
        UNARCHIVE: 'tutors.unarchive',
        LESSONS_CONDUCT: 'tutors.lessons.conduct',
        STUDENTS_TRANSFER: 'tutors.students.transfer',
        FINANCE_READ: 'tutors.finance.read',
        PAYOUTS_CREATE: 'tutors.payouts.create',
        PAYOUTS_CANCEL: 'tutors.payouts.cancel',
        PAYOUTS_READ: 'tutors.payouts.read',
        RECEIPTS_CREATE: 'tutors.receipts.create',
        RECEIPTS_READ: 'tutors.receipts.read',
        RECEIPTS_DELETE: 'tutors.receipts.delete',
        LESSONS_LIST: 'tutors.lessons.list',
        PENALTY_BONUS_READ: 'tutors.penalty_bonus.read',
        PENALTIES_BONUSES_READ: 'tutors.penalties_bonuses.read',
        PENALTIES_BONUSES_SELF_READ: 'tutors.penalties_bonuses.self.read',
        PENALTIES_BONUSES_CREATE: 'tutors.penalties_bonuses.create',
        STUDENTS_READ: 'tutors.students.read',
        SANCTION_SEQUENCE_RESET: 'tutor.sanction_sequence.reset',
    },
    FINANCE: {
        LIST: 'finance.list',
        BY_WORK_TGS_LIST: 'finance.list',
        PAYMENTS_LIST: 'finance.payments.list',
        TUTOR_READ: 'tutors.finance.read',
        VIEW_FULL: 'finance.view.full',
        VIEW_PARTIAL: 'finance.view.partial',
        DETAILS_DOWNLOAD: 'finance.details.download',
        CONTRACTS_DOWNLOAD_ALL: 'finance.contracts.download_all',
        RECEIPTS_DOWNLOAD_ALL: 'finance.receipts.download_all',
    },
    BILLING: {
        PENALTIES_BONUSES_VISIBLE_READ: 'billing.penalties_bonuses.visible.read',
    },
    STUDENTS: {
        LIST: 'students.list',
        CREATE: 'students.create',
        VIEW_TUTOR: 'students.view.tutor',
        VIEW_FULL: 'students.view.full',
        CARD_READ: 'student.card.read',
        CARD_TUTOR_CHANGE: 'student.card.tutor.change',
        CARD_ARCHIVE: 'student.card.archive',
        CARD_UNARCHIVE: 'student.card.unarchive',
        CARD_UPDATE: 'student.card.update',
        CARD_DELETE: 'student.card.delete',
        CARD_PAYMENT_UPDATE: 'student.card.payment.update',
        CARD_WALLET_UPDATE: 'student.card.wallet.update',
        CARD_PAYMENT_LINK_COPY: 'student.card.payment_link.copy',
        CARD_FINANCE_READ: 'student.card.finance.read',
        SANCTION_SEQUENCE_RESET: 'student.sanction_sequence.reset',
        CARD_COMMENTS_READ: 'student.card.comments.read',
        CARD_COMMENTS_CREATE: 'student.card.comments.create',
        LESSONS_LIST: 'students.lessons.list',
        TRANSACTIONS_LIST: 'students.transactions.list',
        TRANSACTIONS_MANUAL_CREATE: 'students.transactions.manual.create',
        TRANSACTIONS_MANUAL_DELETE: 'students.transactions.manual.delete',
        TAGS_LIST: 'students.tags.list',
        TAGS_STUDENT_LIST: 'students.tags.student.list',
        TAGS_CREATE: 'students.tags.create',
        TAGS_UPDATE: 'students.tags.update',
        TAGS_DELETE: 'students.tags.delete',
        TAGS_ASSIGN: 'students.tags.assign',
        TAGS_REMOVE: 'students.tags.remove',
    },
    WORK_TGS: {
        LIST: 'work_tgs.list',
        CREATE: 'work_tgs.create',
        UPDATE: 'work_tgs.update',
        DELETE: 'work_tgs.delete',
        ASSIGN_USER: 'work_tgs.assign_user',
        MULTIPLE_AVAILABLE: 'work_tgs.multiple_available',
    },
    TEAMS: {
        READ: 'teams.read',
        MANAGE: 'teams.manage',
    },
    LESSONS: {
        LIST: 'section.calendar',
        UPDATE: 'section.calendar',
        DELETE: 'section.calendar',
        TUTOR_TRIAL_CONDUCT: 'tutors.lessons.conduct',
        TUTOR_CONDUCT: 'tutors.lessons.conduct',
        TUTOR_LIST: 'tutors.lessons.list',
        STUDENT_LIST: 'students.lessons.list',
        CALENDAR_TUTOR_READ: 'calendar.tutor.read',
        REOPEN_CANCELLED: 'calendar.lesson.cancel',
    },
    SCHEDULE: {
        TUTOR_AVAILABILITY_UPDATE: 'schedule.tutor_availability.update',
        STUDENT_REGULAR_UPDATE: 'schedule.student_regular.update',
        STUDENT_REGULAR_DELETE: 'schedule.student_regular.delete',
    },
    DOCUMENTS: {
        VIEW: 'idm.contract.read',
        ADD: 'idm.contract.update',
    },
    TRIAL_LESSONS: {
        CALENDAR_READ: 'trial.calendar.read',
        READ: 'trial.lesson.read',
        CREATE: 'trial.lesson.create',
		SLOT_CREATE: 'trial.slot.create_trial_lesson',
        AVAILABLE_TUTORS_READ: 'trial.available_tutors.read',
        COMPLETE: 'trial.lesson.complete',
        CREATE_STUDENT: 'trial.lesson.create_student',
        MARK_LOST: 'trial.lesson.mark_lost',
        REOPEN_LOST: 'trial.lesson.reopen_lost',
        EDIT: 'trial.lesson.edit',
        DELETE: 'trial.lesson.delete',
        RESCHEDULE: 'trial.lesson.reschedule',
        VIEW_PRIVATE_INFO: 'trial.lesson.view_private_info',
    },
    SHIFTS: {
        READ: 'shifts.read',
        ASSIGN: 'shifts.assign',
        REPLACE_COORDINATOR: 'shifts.replace_coordinator',
        REPLACE_CURATOR: 'shifts.replace_curator',
        PATTERN_UPDATE: 'shifts.pattern.update',
    },
    EVENTS: {
        LIST: 'events.lesson_events.list',
        VIEW: 'events.lesson_events.view',
        REVIEW: 'events.lesson_events.review',
    },
    STATISTICS: {
        VIEW: 'statistics.view',
    },
    LEGAL_INFO: {
        READ: 'legal_info.read',
        MANAGE: 'legal_info.manage',
    },
    LEGAL_DOCUMENTS: {
        READ: 'legal_documents.read',
        MANAGE: 'legal_documents.manage',
    },
    TRANSACTIONS: {
        LIST: 'transactions.list',
        MANUAL_CREATE: 'transactions.manual.create',
        STUDENT_LIST: 'students.transactions.list',
        STUDENT_MANUAL_CREATE: 'students.transactions.manual.create',
        STUDENT_MANUAL_DELETE: 'students.transactions.manual.delete',
    },
    PROFILE: {
        PAYMENT_DETAILS_READ: 'profile.payment_details.read',
        PAYMENT_DETAILS_UPDATE: 'profile.payment_details.update',
    },
    AUDIT: {
        SCHEDULE_HISTORY_READ: 'audit.schedule_history.read',
    },
    IDM: {
        STAFF_LIST: 'idm.staff.list',
        STAFF_AVAILABLE_COORDINATORS: 'idm.staff.available_coordinators',
        STAFF_AVAILABLE_CURATORS: 'idm.staff.available_curators',
        STAFF_READ: 'idm.staff.read',
        STAFF_ACCRUALS_READ: 'idm.staff.accruals.read',
        STAFF_CREATE: 'idm.staff.create',
        STAFF_DELETE: 'idm.staff.delete',
        STAFF_ARCHIVE: 'idm.staff.archive',
        STAFF_UNARCHIVE: 'idm.staff.unarchive',
        STAFF_PAYMENT_DETAILS_UPDATE: 'idm.staff.payment_details.update',
        USER_PASSWORD_RESET: 'idm.user_password.reset',
        PERSONAL_UPDATE: 'idm.staff.update',
        STAFF_TAGS_ASSIGN: 'idm.staff.tags.assign',
        WORK_TGS_UPDATE: 'idm.work_tgs.update',
        PENALTIES_BONUSES_READ: 'idm.penalties_bonuses.read',
        PENALTIES_BONUSES_CREATE: 'idm.penalties_bonuses.create',
        ROLES_LIST: 'idm.roles.list',
        FEATURES_LIST: 'idm.features.list',
        ROLE_FEATURES_LIST: 'idm.role_features.list',
        ROLE_FEATURES_ADD: 'idm.role_features.add',
        ROLE_FEATURES_REMOVE: 'idm.role_features.remove',
        USER_FEATURES_LIST: 'idm.user_features.list',
        USER_AVAILABLE_FEATURES_LIST: 'idm.user_available_features.list',
        USER_ROLES_ASSIGN: 'idm.user_roles.assign',
        USER_ROLES_REMOVE: 'idm.user_roles.remove',
        USER_FEATURES_GRANT: 'idm.user_features.grant',
        USER_FEATURES_REVOKE: 'idm.user_features.revoke',
        USER_FEATURES_TARGETS_REPLACE: 'idm.user_features.targets.replace',
        CONTRACT_READ: 'idm.contract.read',
        CONTRACT_UPDATE: 'idm.contract.update',
    },
} as const

const collectFeatureKeys = (value: unknown): string[] => {
    if (typeof value === 'string') {
        return [value]
    }

    if (value && typeof value === 'object') {
        return Object.values(value).flatMap(collectFeatureKeys)
    }

    return []
}

/** Полный набор новых прав, удобный для локальной разработки и моков. */
export const ALL_AVAILABLE_FEATURES = [
    ...Object.values(FEATURE_SECTIONS),
    ...collectFeatureKeys(FEATURES),
]
